import type { ComposerEditorLinkProps } from '@liveblocks/react-ui/primitives'
import { Composer } from '@liveblocks/react-ui/primitives'

export const EditorLink = ({ href, children }: ComposerEditorLinkProps) => (
  <Composer.Link href={href} className='text-main-foreground-accent underline'>
    {children}
  </Composer.Link>
)
